import { render, staticRenderFns } from "./HistoryNew.vue?vue&type=template&id=6b78639c&scoped=true&"
import script from "./HistoryNew.vue?vue&type=script&lang=js&"
export * from "./HistoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78639c",
  null
  
)

export default component.exports